// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { loadingOverflow } from "@eisinc/App/SharedStyles/GeneralStyles";
import { brandsPageStyles } from "@eisinc/Overrides/Pages/BrandsPage";
import ChevronUp from "@eisinc/XDL/Icons/ChevronUp";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css, keyframes } from "styled-components";

const arrowUp = keyframes`
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(-3px);
  }
`;

brandsPageStyles.loadingOverlay = {
    ...loadingOverflow,
};

brandsPageStyles.buttons = {
    css: css`
        position: sticky;
        bottom: 100px;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
        opacity: 0.75;
        margin-left: auto;
        &:hover {
            ${IconWrapper} {
                background-color: ${color("common.ui8")};
            }

            ${TypographyStyle} {
                            border-color: ${color("common.ui8")};
                color: ${color("common.ui8")};
            }
            svg {
                animation: ${arrowUp} 0.4s ease infinite;
            }
        }
        &:focus {
            ${IconWrapper} {
                background-color: ${color("common.ui9")};
            }
            ${TypographyStyle} {
                            border-color: ${color("common.ui9")};
                color: ${color("common.ui9")};
            }
        }
    `,
};

brandsPageStyles.backToTopButton = {
    css: css`
        background: transparent;
        border: 1px solid ${color("primary")};
        color: ${color("primary")};
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 34px;
        line-height: ${fontConfig.singleLineSmall.lineHeight};
        font-size: ${fontConfig.singleLineSmall.size}px;
        padding: 0 20px;
        text-transform: uppercase;
        font-weight: ${fontConfig.weight.medium};
    `,
};

brandsPageStyles.backToTopIcon = {
    src: ChevronUp,
    color: "common.white",
    size: 12,
    css: css`
        background-color: ${color("primary")};
        height: 34px;
        width: auto;
        margin-right: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 4px;
    `,
};
